export default state => state.page.data.devices;
